<template>
  <a-modal title="操作" style="top: 20px" :width="900" v-model="visible" :footer="false" :maskClosable="false">
    <div v-if="added == 2">
      <!-- 正常流程标题 -->
      <div v-if="payment == 0">
        <a-steps :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
      </div>
      <!--后付款流程标题-->
      <div v-if="payment == 1">
        <a-steps :current="current2">
          <a-step v-for="item in steps2" :key="item.title" :title="item.title" />
        </a-steps>
      </div>

      <div class="steps-action">
        <!-- 正常流程 第一步-->
        <div v-if="current == 0 && dispatch == 0">
          <div v-if="idss == 1">
            <a-form :form="form">
              <a-form-item style="display: none">
                <a-input v-decorator="['purchaseOrderId']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
                <a-input v-model="purchaseOrderNo" disabled="disabled" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间" style="position: relative">
                <span style="color: red; position: absolute; left: -78px">*</span>
                <a-date-picker @change="onChangeTiem" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 供应商" style="position: relative">
                <span style="color: red; position: absolute; left: -65px">*</span>
                <a-select @change="onChange3" v-model="supplierName">
                  <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                    item.supplierName
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式" style="position: relative">
                <span style="color: red; position: absolute; left: -78px">*</span>
                <a-select @change="onChange4" v-model="payment">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 是否开票" style="position: relative">
                <span style="color: red; position: absolute; left: -78px">*</span>
                <a-select v-model="invoice">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件" style="position: relative">
                <span style="color: red; position: absolute; left: -50px">*</span>
                <a-select @change="onChange2" v-molde="accessoryName">
                  <a-select-option v-for="item in parts" :value="item.accessoryId"
                    >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
                    {{ item.accessorySpecification }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量" style="position: relative">
                <span style="color: red; position: absolute; left: -50px">*</span>
                <a-input @blur="accessoryNumberBlur" v-model="accessoryNumber" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价" style="position: relative">
                <span style="color: red; position: absolute; left: -50px">*</span>
                <a-input @blur="priceBlur" v-model="price" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input v-model="remark" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
                <a-input v-model="total_price" disabled="disabled" />
              </a-form-item>
            </a-form>
            <div>
              <a-button class="editable-add-btn" @click="handleAdd2">添加</a-button>
              <a-table bordered :dataSource="dataSource" :columns="columns">
                <template slot="purchasePrice" slot-scope="text, record">
                  <editable-cell :text="text" @change="onCellChange(record.key, 'purchasePrice', $event)" />
                </template>
                <template slot="operation" slot-scope="text, record">
                  <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </div>
          </div>

          <div v-if="idss == 2">
            <a-form :form="form">
              <a-form-item style="display: none">
                <a-input v-decorator="['purchaseOrderId']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
                <a-input v-model="purchaseOrderNo" disabled="disabled" />
              </a-form-item>
              <!--              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间" style="position: relative">-->
              <!--                <span style="color: red;position: absolute;left: -78px;">*</span>-->
              <!--                <a-date-picker      @change="onChangeTiem"  />-->
              <!--              </a-form-item>-->

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 供应商" style="position: relative">
                <span style="color: red; position: absolute; left: -65px">*</span>
                <a-select @change="onChange3" v-model="supplierName">
                  <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                    item.supplierName
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式" style="position: relative">
                <span style="color: red; position: absolute; left: -78px">*</span>
                <a-select @change="onChange4" v-model="payment">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 是否开票" style="position: relative">
                <span style="color: red; position: absolute; left: -78px">*</span>
                <a-select v-model="invoice">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
                <a-input v-model="total_price" disabled="disabled" />
              </a-form-item>
            </a-form>
            <div>
              <!--              <a-button class="editable-add-btn" @click="handleAdd2">添加</a-button>-->
              <a-table bordered :dataSource="dataSource" :columns="columns">
                <template slot="purchasePrice" slot-scope="text, record">
                  <editable-cell :text="text" @change="onCellChange(record.key, 'purchasePrice', $event)" />
                </template>
                <template slot="operation" slot-scope="text, record">
                  <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- 后付款流程 第一步-->
        <div v-if="current2 == 0 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker @change="onChangeTiem" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商ID">
              <a-select @change="onChange3" v-model="supplierName">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange4" v-model="payment">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
              <a-select @change="onChange2" v-model="accessoryName">
                <a-select-option v-for="item in parts" :value="item.accessoryId"
                  >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
                  {{ item.accessorySpecification }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
              <a-input @blur="accessoryNumberBlur" v-model="accessoryNumber" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
              <a-input @blur="priceBlur" v-model="price" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input v-model="remark" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" />
            </a-form-item>
          </a-form>
          <div>
            <a-button class="editable-add-btn" @click="handleAdd2">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>
        </div>

        <!-- 正常流程 第二步-->
        <div v-if="current == 1 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker @change="onChangeTiem" v-model="needTime" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange4" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                  disabled="disabled"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-input v-model="accountName" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行账号" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-input
                v-model="accountNumber"
                autocomplete="off"
                v-decorator="['accountNumber', { rules: [{ validator: this.bankNum, required: false }] }]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="bankName"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
              <!--<a-input v-model="bankName" />-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangetiem2" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangeTiem3" />
              <!--        <a-input  v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList2"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>
        <!-- 后付款流程 第二步-->
        <div v-if="current2 == 1 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker @change="onChange" v-model="needTime" disabled="disabled" />
              <!--        <a-input  v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange3" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>

          <a-form :form="form4">
            <span>
              <a-button
                style="width: 110px; margin-left: 60%"
                type="primary"
                ghost
                @click="handleadd1"
                :disabled="isDisable1"
                >添加物流信息</a-button
              >
            </span>
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-select v-model="item.transportCode">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option
                  >-->
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-input v-model="item.transportNo" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-select v-model="item.transportStatus">
                  <a-select-option :value="0">未发货</a-select-option>-->
                  <a-select-option :value="1">发货中</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" :disabled="isDisable3">删除</a-button>
              </a-form-item>
            </div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList4"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>

        <!-- 正常流程 第三步-->
        <div v-if="current == 2 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select disabled="disabled" v-model="payment">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangeTime4" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList3"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>
        <!-- 后付款流程 第三步-->
        <div v-if="current2 == 2 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" @change="onChange" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange3" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form4">
            <span>
              <a-button
                style="width: 110px; margin-left: 60%"
                type="primary"
                ghost
                @click="handleadd1"
                disabled="disabled"
                >添加物流</a-button
              >
            </span>
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportCode" disabled="disabled">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.transportNo" disabled="disabled" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportStatus" disabled="disabled">
                  <a-select-option :value="0">未发货</a-select-option>
                  <a-select-option :value="1">发货中</a-select-option>
                  <a-select-option :value="2">确认收货</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" disabled="disabled">删除</a-button>
              </a-form-item>
            </div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" v-model="expectedDeliveryTime" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists4"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-input v-model="accountName" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行账号" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-input
                v-model="accountNumber"
                autocomplete="off"
                v-decorator="['accountNumber', { rules: [{ validator: this.bankNum, required: false }] }]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="bankName"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
              <!--<a-input  v-model="bankName" />-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangetiem2" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangeTiem3" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList2"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>

        <!-- 正常流程 第四步-->
        <div v-if="current == 3 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select disabled="disabled" v-model="payment">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间">
              <a-date-picker @change="onChangeTime4" v-model="paymentCompletionTime" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" disabled="disabled" />
            </a-form-item>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists3"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </a-form>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>

          <a-form :form="form4">
            <span>
              <a-button
                style="width: 110px; margin-left: 60%"
                type="primary"
                ghost
                @click="handleadd1"
                :disabled="isDisable1"
                >添加物流</a-button
              >
            </span>
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-select v-model="item.transportCode">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option
                  >-->
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-input v-model="item.transportNo" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-select v-model="item.transportStatus">
                  <a-select-option :value="0">未发货</a-select-option>-->
                  <a-select-option :value="1">发货中</a-select-option>
                  <!--                  <a-select-option :value="2">确认收货</a-select-option>-->
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" :disabled="isDisable3">删除</a-button>
              </a-form-item>
            </div>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList4"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>
        <!-- 后付款流程 第四步-->
        <div v-if="current2 == 3 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" @change="onChange" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange3" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form4">
            <span>
              <a-button
                style="width: 110px; margin-left: 60%"
                type="primary"
                ghost
                @click="handleadd1"
                disabled="disabled"
                >添加</a-button
              >
            </span>
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportCode" disabled="disabled">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.transportNo" disabled="disabled" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportStatus" disabled="disabled">
                  <a-select-option :value="0">未发货</a-select-option>
                  <a-select-option :value="1">发货中</a-select-option>
                  <a-select-option :value="2">确认收货</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" disabled="disabled">删除</a-button>
              </a-form-item>
            </div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" v-model="expectedDeliveryTime" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists4"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangeTime4" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList3"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>

        <!-- 正常流程 第五步-->
        <div v-if="current == 4 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商ID">
              <a-select v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select
                disabled="disabled"
                v-decorator="['payment', { rules: [{ required: true, message: '付款方式' }] }]"
              >
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>
          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间">
              <a-date-picker @change="onChangeTime4" v-model="paymentCompletionTime" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists3"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form4">
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportCode" disabled="disabled">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.transportNo" disabled="disabled" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportStatus" disabled="disabled">
                  <a-select-option :value="0">未发货</a-select-option>
                  <a-select-option :value="1">发货中</a-select-option>
                  <a-select-option :value="2">确认收货</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" disabled="disabled">删除</a-button>
              </a-form-item>
            </div>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" v-model="expectedDeliveryTime" disabled="disabled" />
            </a-form-item>
          </a-form>
          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists4"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form5">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="签收时间" style="position: relative">
              <span style="color: red; position: absolute; left: -80px">*</span>
              <a-date-picker @change="onChangeTiem5" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入库备注">
              <a-input v-model="procurementRemark" />
            </a-form-item>
          </a-form>

          <a-button style="float: right" type="primary" @click="returnGoods"> 退货 </a-button>
        </div>

        <!-- 后付款流程 第五步-->
        <div v-if="current2 == 4 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" @change="onChange" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange3" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form4">
            <!--                  <span>-->
            <!--                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>-->
            <!--                </span>-->
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportCode" disabled="disabled">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.transportNo" disabled="disabled" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportStatus" disabled="disabled">
                  <a-select-option :value="0">未发货</a-select-option>
                  <a-select-option :value="1">发货中</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" disabled="disabled">删除</a-button>
              </a-form-item>
            </div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" v-model="expectedDeliveryTime" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists4"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间">
              <a-date-picker @change="onChangeTime4" v-model="paymentCompletionTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists3"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form5">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="签收时间" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-date-picker format="YYYY-MM-DD" @change="onChangeTiem5" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入库备注">
              <a-input v-model="procurementRemark" />
            </a-form-item>

            <!--            <a-button style="left: 200px"  type="primary" @click="warehousing">-->
            <!--              入库-->
            <!--            </a-button>-->
          </a-form>
          <a-button style="float: right" type="primary" @click="returnGoods"> 退货 </a-button>
        </div>

        <!--先付款-->
        <div v-if="payment == 0 && idss == 1">
          <a-button v-if="current < steps.length - 1" type="primary" @click="next"> 下一步 </a-button>
          <a-button v-if="current == steps.length - 1" type="primary" @click="next"> 确定 </a-button>
          <a-button v-if="current > 0" style="margin-left: 8px" @click="prev"> 上一步 </a-button>
        </div>

        <!--先付款-->
        <div v-if="payment == 0 && idss == 2">
          <a-button v-if="current < steps.length - 1" type="primary" @click="next"> 确定 </a-button>
          <a-button v-if="current == steps.length - 1" type="primary" @click="next"> 确定 </a-button>
          <a-button v-if="current > 0" style="margin-left: 8px" @click="prev"> 上一步 </a-button>
        </div>

        <!--后付款-->
        <div v-if="payment == 1">
          <a-button v-if="current2 < steps2.length - 1" type="primary" @click="next2"> 下一步 </a-button>
          <a-button v-if="current2 == steps2.length - 1" type="primary" @click="next2"> 确定 </a-button>
          <a-button v-if="current2 > 0" style="margin-left: 8px" @click="prev2"> 上一步 </a-button>
        </div>
      </div>
    </div>

    <!--查看-->
    <div v-if="added == 3">
      <!-- 正常流程标题 -->
      <div v-if="payment == 0">
        <a-steps :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
      </div>
      <!--后付款流程标题-->
      <div v-if="payment == 1">
        <a-steps :current="current2">
          <a-step v-for="item in steps2" :key="item.title" :title="item.title" />
        </a-steps>
      </div>

      <div class="steps-action">
        <!-- 正常流程 第一步-->
        <div v-if="current == 0 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-date-picker @change="onChangeTiem" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 供应商" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-select @change="onChange3" v-model="supplierName">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-select @change="onChange4" v-model="payment">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 是否开票" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-select v-model="invoice">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件" style="position: relative">
              <span style="color: red; position: absolute; left: -50px">*</span>
              <a-select @change="onChange2" v-molde="accessoryName">
                <a-select-option v-for="item in parts" :value="item.accessoryId"
                  >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
                  {{ item.accessorySpecification }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量" style="position: relative">
              <span style="color: red; position: absolute; left: -50px">*</span>
              <a-input @blur="accessoryNumberBlur" v-model="accessoryNumber" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价" style="position: relative">
              <span style="color: red; position: absolute; left: -50px">*</span>
              <a-input @blur="priceBlur" v-model="price" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input v-model="remark" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button class="editable-add-btn" @click="handleAdd2">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="purchasePrice" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'purchasePrice', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>
        </div>
        <!-- 后付款流程 第一步-->x
        <div v-if="current2 == 0 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker @change="onChangeTiem" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商ID">
              <a-select @change="onChange3" v-model="supplierName">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange4" v-model="payment">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
              <a-select @change="onChange2" v-model="accessoryName">
                <a-select-option v-for="item in parts" :value="item.accessoryId"
                  >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
                  {{ item.accessorySpecification }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
              <a-input @blur="accessoryNumberBlur" v-model="accessoryNumber" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
              <a-input @blur="priceBlur" v-model="price" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input v-model="remark" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" />
            </a-form-item>
          </a-form>
          <div>
            <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>
        </div>

        <!-- 正常流程 第二步-->
        <div v-if="current == 1 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker @change="onChangeTiem" v-model="needTime" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange4" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                  disabled="disabled"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-input v-model="accountName" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行账号" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-input
                v-model="accountNumber"
                autocomplete="off"
                v-decorator="['accountNumber', { rules: [{ validator: this.bankNum, required: false }] }]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-input v-model="bankName" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangetiem2" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangeTiem3" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList2"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>
        <!-- 后付款流程 第二步-->
        <div v-if="current2 == 1 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker @change="onChange" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange3" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>

          <a-form :form="form4">
            <span>
              <a-button
                style="width: 110px; margin-left: 60%"
                type="primary"
                ghost
                @click="handleadd1"
                :disabled="isDisable1"
                >添加物流信息</a-button
              >
            </span>
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-select v-model="item.transportCode">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option
                  >-->
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-input v-model="item.transportNo" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-select v-model="item.transportStatus">
                  <a-select-option :value="0">未发货</a-select-option>-->
                  <a-select-option :value="1">发货中</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" :disabled="isDisable3">删除</a-button>
              </a-form-item>
            </div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList4"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>

        <!-- 正常流程 第三步-->
        <div v-if="current == 2 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select disabled="disabled" v-model="payment">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm disabled="disabled" title="确认删除吗？" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangeTime4" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList3"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>
        <!-- 后付款流程 第三步-->
        <div v-if="current2 == 2 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" @change="onChange" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange3" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form4">
            <span>
              <a-button
                style="width: 110px; margin-left: 60%"
                type="primary"
                ghost
                @click="handleadd1"
                disabled="disabled"
                >添加物流</a-button
              >
            </span>
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportCode" disabled="disabled">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.transportNo" disabled="disabled" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportStatus" disabled="disabled">
                  <a-select-option :value="0">未发货</a-select-option>
                  <a-select-option :value="1">发货中</a-select-option>
                  <a-select-option :value="2">确认收货</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" disabled="disabled">删除</a-button>
              </a-form-item>
            </div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" v-model="expectedDeliveryTime" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists3"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-input v-model="accountName" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行账号" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-input
                v-model="accountNumber"
                autocomplete="off"
                v-decorator="['accountNumber', { rules: [{ validator: this.bankNum, required: false }] }]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行" style="position: relative">
              <span style="color: red; position: absolute; left: -65px">*</span>
              <a-input v-model="bankName" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangetiem2" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangeTiem3" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList2"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>

        <!-- 正常流程 第四步-->
        <div v-if="current == 3 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select disabled="disabled" v-model="payment">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间">
              <a-date-picker @change="onChangeTime4" v-model="paymentCompletionTime" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" disabled="disabled" />
            </a-form-item>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists3"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </a-form>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>

          <a-form :form="form4">
            <span>
              <a-button
                style="width: 110px; margin-left: 60%"
                type="primary"
                ghost
                @click="handleadd1"
                :disabled="isDisable1"
                >添加物流</a-button
              >
            </span>
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-select v-model="item.transportCode">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option
                  >-->
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-input v-model="item.transportNo" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red; position: absolute; left: -80px">*</span>
                <a-select v-model="item.transportStatus">
                  <a-select-option :value="0">未发货</a-select-option>-->
                  <a-select-option :value="1">发货中</a-select-option>
                  <!--                  <a-select-option :value="2">确认收货</a-select-option>-->
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" :disabled="isDisable3">删除</a-button>
              </a-form-item>
            </div>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList4"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>
        <!-- 后付款流程 第四步-->
        <div v-if="current2 == 3 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" @change="onChange" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange3" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm disabled="disabled" title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form4">
            <span>
              <a-button
                style="width: 110px; margin-left: 60%"
                type="primary"
                ghost
                @click="handleadd1"
                disabled="disabled"
                >添加</a-button
              >
            </span>
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportCode" disabled="disabled">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.transportNo" disabled="disabled" />
              </a-form-item>

              <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportStatus" disabled="disabled">
                  <a-select-option :value="0">未发货</a-select-option>
                  <a-select-option :value="1">发货中</a-select-option>
                  <a-select-option :value="2">确认收货</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" disabled="disabled">删除</a-button>
              </a-form-item>
            </div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" v-model="expectedDeliveryTime" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists4"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm disabled="disabled" title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" style="position: relative">
              <span style="color: red; position: absolute; left: -105px">*</span>
              <a-date-picker @change="onChangeTime4" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" />
            </a-form-item>
          </a-form>

          <span>
            <a-upload
              name="file"
              :fileList="fileList3"
              :action="uploadUrlb2"
              :headers="headers"
              @change="uploadChange"
              showUploadList="false"
            >
              <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
            </a-upload>
          </span>
        </div>

        <!-- 正常流程 第五步-->
        <div v-if="current == 4 && dispatch == 0">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商ID">
              <a-select v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select
                disabled="disabled"
                v-decorator="['payment', { rules: [{ required: true, message: '付款方式' }] }]"
              >
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns2"
              :dataSource="fileLists"
              bordered
            >
              <span slot="action2" slot-scope="text, record">
                <a @click="delByIds(record)">下载</a>
                <a-divider type="vertical" />
                <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
                <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
                <a-divider type="vertical" />
                <a-popconfirm disabled="disabled" title="确认删除吗？" @confirm="() => delContract(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>
          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间">
              <a-date-picker @change="onChangeTime4" v-model="paymentCompletionTime" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists3"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" disabled="disabled" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form4">
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportCode" disabled="disabled">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.transportNo" disabled="disabled" />
              </a-form-item>

              <div v-if="operateTransport == 1">
                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="item.transportStatus">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>
              </div>

              <div v-if="operateTransport != 1">
                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>
              </div>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" disabled="disabled">删除</a-button>
              </a-form-item>
            </div>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" v-model="expectedDeliveryTime" disabled="disabled" />
            </a-form-item>
          </a-form>
          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists4"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 0" @click="disableContract(record)">启用</a>
              <a v-if="record.forbiddenStatus == 1" @click="enableContract(record)">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form5">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="签收时间" style="position: relative">
              <span style="color: red; position: absolute; left: -80px">*</span>
              <a-date-picker @change="onChangeTiem5" v-model="takeOverTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入库备注">
              <a-input v-model="procurementRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <!--            <a-button style="float: right;"  type="primary" @click="returnGoods">-->
          <!--              退货-->
          <!--            </a-button>-->
        </div>

        <!-- 后付款流程 第五步-->
        <div v-if="current2 == 4 && dispatch == 1">
          <a-form :form="form">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
              <a-input v-model="purchaseOrderNo" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
              <a-date-picker format="YYYY-MM-DD" @change="onChange" v-model="needTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select @change="onChange3" v-model="supplierId" disabled="disabled">
                <a-select-option v-for="item in boxLis" :value="item.supplierId">{{
                  item.supplierName
                }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
              <a-select @change="onChange3" v-model="payment" disabled="disabled">
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
              <a-select v-model="invoice" disabled="disabled">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
              <a-input v-model="total_price" disabled="disabled" />
            </a-form-item>
          </a-form>
          <div>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form4">
            <!--                  <span>-->
            <!--                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>-->
            <!--                </span>-->
            <div v-for="(item, i) in storeLogistics" :key="i">
              <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="item.transportCode" disabled="disabled">
                  <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.transportNo" disabled="disabled" />
              </a-form-item>

              <div v-if="operateTransport == 1">
                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="item.transportStatus">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>
              </div>

              <div v-if="operateTransport != 1">
                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>
              </div>

              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost @click="removeTab1(item)" disabled="disabled">删除</a-button>
              </a-form-item>
            </div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货时间">
              <a-date-picker @change="estimated" v-model="expectedDeliveryTime" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists4"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm disabled="disabled" title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form2">
            <a-form-item style="display: none">
              <a-input v-decorator="['purchaseOrderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
              <a-input v-model="accountName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
              <a-input v-model="accountNumber" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
              <a-input v-model="bankName" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间">
              <a-date-picker @change="onChangetiem2" v-model="expectedPaymentTimeBegin" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间">
              <a-date-picker @change="onChangeTiem3" v-model="expectedPaymentTimeEnd" disabled="disabled" />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input v-model="paymentRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists2"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm disabled="disabled" title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间">
              <a-date-picker @change="onChangeTime4" v-model="paymentCompletionTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input v-model="paymentCompletionRemark" disabled="disabled" />
            </a-form-item>
          </a-form>

          <a-table
            size="default"
            ref="table"
            :pagination="pagination"
            :columns="columns2"
            :dataSource="fileLists3"
            bordered
          >
            <span slot="action2" slot-scope="text, record">
              <a @click="delByIds(record)">下载</a>
              <a-divider type="vertical" />
              <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
              <a v-if="record.forbiddenStatus == 0" @click="enableContract(record)" disabled="disabled">禁用</a>
              <a-divider type="vertical" />
              <a-popconfirm disabled="disabled" title="确认删除吗？" @confirm="() => delContract(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
          </a-table>

          <div style="width: 100%; height: 1px; border-top: solid #000000 1px"></div>
          <a-form :form="form5">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="签收时间" style="position: relative">
              <span style="color: red; position: absolute; left: -78px">*</span>
              <a-date-picker format="YYYY-MM-DD" @change="onChangeTiem5" v-model="takeOverTime" disabled="disabled" />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入库备注">
              <a-input v-model="procurementRemark" disabled="disabled" />
            </a-form-item>

            <!--            <a-button style="left: 200px"  type="primary" @click="warehousing">-->
            <!--              入库-->
            <!--            </a-button>-->
          </a-form>
          <!--            <a-button style="float: right"  type="primary" @click="returnGoods">-->
          <!--              退货-->
          <!--            </a-button>-->
        </div>

        <span style="display: flex; justify-content: flex-end">
          <a-button style="margin-right: 20px" @click="handleSubmit2">取消</a-button>
          <a-button @click="handleSubmit" :loading="iconLoading" type="primary">确认</a-button>
        </span>
      </div>
    </div>

    <div v-if="added == 1">
      <a-form :form="form">
        <a-form-item style="display: none">
          <a-input v-decorator="['purchaseOrderId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
          <a-input v-model="purchaseOrderNo" disabled="disabled" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间" style="position: relative">
          <span style="color: red; position: absolute; left: -78px">*</span>
          <a-date-picker @change="onChangeTiem" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 供应商" style="position: relative">
          <span style="color: red; position: absolute; left: -65px">*</span>
          <a-select @change="onChange3" v-model="supplierName">
            <a-select-option v-for="item in boxLis" :value="item.supplierId">{{ item.supplierName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式" style="position: relative">
          <span style="color: red; position: absolute; left: -78px">*</span>
          <a-select @change="onChange4" v-model="payment">
            <a-select-option value="0">先付款</a-select-option>
            <a-select-option value="1">后付款</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 是否开票" style="position: relative">
          <span style="color: red; position: absolute; left: -78px">*</span>
          <a-select v-model="invoice">
            <a-select-option value="0">不开票</a-select-option>
            <a-select-option value="1">开票</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件" style="position: relative">
          <span style="color: red; position: absolute; left: -50px">*</span>
          <a-select @change="onChange2" v-molde="accessoryName">
            <a-select-option v-for="item in parts" :value="item.accessoryId"
              >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
              {{ item.accessorySpecification }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量" style="position: relative">
          <span style="color: red; position: absolute; left: -50px">*</span>
          <a-input @blur="accessoryNumberBlur" v-model="accessoryNumber" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价" style="position: relative">
          <span style="color: red; position: absolute; left: -50px">*</span>
          <a-input @blur="priceBlur" v-model="price" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input v-model="remark" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
          <a-input v-model="total_price" disabled="disabled" />
        </a-form-item>
      </a-form>
      <div>
        <a-button class="editable-add-btn" @click="handleAdd2">添加</a-button>
        <a-table bordered :dataSource="dataSource" :columns="columns">
          <template slot="purchasePrice" slot-scope="text, record">
            <editable-cell :text="text" @change="onCellChange(record.key, 'purchasePrice', $event)" />
          </template>

          <template slot="remark" slot-scope="text, record">
            <editable-cell :text="text" @change="onCellChange(record.key, 'remark', $event)" />
          </template>

          <template slot="operation" slot-scope="text, record">
            <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
        <span>
          <a-upload
            name="file"
            :fileList="fileList1"
            :action="uploadUrlb2"
            :headers="headers"
            @change="uploadChange"
            showUploadList="false"
          >
            <a-button class="twobtn" style="margin-left: 10px; margin-bottom: 20px" type="primary">上传附件</a-button>
          </a-upload>
        </span>
      </div>

      <span style="display: flex; justify-content: flex-end">
        <a-button style="margin-right: 20px" @click="handleSubmit2">取消</a-button>
        <a-button @click="handleSubmit" :loading="iconLoading" type="primary">确认</a-button>
      </span>
    </div>

    <commodity-modal ref="editorder1"></commodity-modal>
  </a-modal>
</template>
<script>
const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    }
  },
  methods: {
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
    },
  },
}
import {
  editPurchaseApplication,
  getPurchasePic,
  delPurchasePic,
  updatePurchaseLogistics,
  checkSupplier,
  manualaccessorystorage,
  selectaccessory2,
  getSupplierPayment,
  getUnitPrice,
  intentiontopurchase,
  getonepurchaseapplication,
  savePurchaseOrder,
  selectaccessory,
  selectenterprise,
  getonepurchaseorder,
  addpurchaseorder,
  editpurchaseorder,
} from '@/api/accessory/stockParts'
import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'
import commodityModal from './commodityModal'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'stockPartsModal',
  props: {},
  components: {
    EditableCell,
    commodityModal: () => import('@/views/accessory/modules/commodityModal'),
  },
  data() {
    return {
      iconLoading: false,
      bankName1: [
        { id: '中国工商银行', name: '中国工商银行' },
        { id: '中国银行', name: '中国银行' },
        { id: '中国建设银行', name: '中国建设银行' },
        { id: '中国农业银行', name: '中国农业银行' },
        { id: '交通银行', name: '交通银行' },
        { id: '中国邮政储蓄银行', name: '中国邮政储蓄银行' },
        { id: '招商银行', name: '招商银行' },
        { id: '上海浦东发展银行', name: '上海浦东发展银行' },
        { id: '民生银行', name: '民生银行' },
        { id: '兴业银行', name: '兴业银行' },
        { id: '中信银行', name: '中信银行' },
        { id: '平安银行', name: '平安银行' },
        { id: '光大银行', name: '光大银行' },
        { id: '华夏银行', name: '华夏银行' },
        { id: '广发银行', name: '广发银行' },
        { id: '上海银行', name: '上海银行' },
        { id: '南京银行', name: '南京银行' },
        { id: '渤海银行', name: '渤海银行' },
        { id: '江苏银行', name: '江苏银行' },
        { id: '恒丰银行', name: '恒丰银行' },
        { id: '徽商银行', name: '徽商银行' },
        { id: '国家开发银行', name: '国家开发银行' },
        { id: '上海农村商业银行', name: '上海农村商业银行' },
        { id: '农村信用社', name: '农村信用社' },
        { id: '农村合作银行', name: '农村合作银行' },
      ],
      idss: 1,
      purchasePicId: '',
      forbiddenStatus: '',
      // 第一步下载文件
      fileLists: '',
      fileName: '',
      fileList1: [],
      // 第二步下载文件
      fileLists2: '',
      fileName2: '',
      fileList2: [],
      // 第三步下载文件
      fileLists3: '',
      fileName3: '',
      fileList3: [],
      // 第四步下载文件
      fileLists4: '',
      fileName4: '',
      fileList4: [],
      // 第五步下载文件
      fileLists5: '',
      fileName5: '',
      fileList5: [],

      columns2: [
        {
          title: '操作',
          width: '170px',
          dataIndex: 'action2',
          scopedSlots: { customRender: 'action2' },
        },
        {
          title: '文件名称',
          width: '200px',
          dataIndex: 'picName',
          scopedSlots: { customRender: 'picName' },
        },
      ],

      uploadUrlb2: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=stock',

      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      enterpriseShow: 0,

      operateTransport: '',
      //采购单预计到货时间
      expectedDeliveryTime: null,
      auditStatus: '',
      form2: this.$form.createForm(this),
      purchasePrice: '0',
      remark: '',
      // 物流
      storeLogistics: [],
      dataSource: [],
      dataSource2: [],
      dispatch: '',
      price: '',
      accessoryNumber: '',
      count: 0,
      count2: 0,
      columns: [
        {
          title: ' 操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
        },
        {
          title: '配件类型',
          dataIndex: 'accessoryType',
        },
        {
          title: '配件型号',
          dataIndex: 'accessoryCategory',
        },
        {
          title: '配件规格',
          dataIndex: 'accessorySpecification',
        },
        {
          title: '采购数量',
          dataIndex: 'accessoryNumber',
        },
        {
          title: '配件单价',
          dataIndex: 'price',
        },
        {
          title: '配件总价',
          dataIndex: 'purchasePrice',
          scopedSlots: { customRender: 'purchasePrice' },
        },
        {
          title: '采购备注',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
        },
      ],
      test: 0,
      // 采够单Id
      purchaseOrderId: '',
      accessoryName: '',
      accessoryType: '',
      accessoryCategory: '',
      accessorySpecification: '',

      // 判断是否是新增
      added: '',
      //需求时间
      timeString: null,
      needTime: null,
      //付款开始时间
      expectedPaymentTimeBegin: null,
      //付款结束时间
      expectedPaymentTimeEnd: null,
      //付款完成时间
      paymentCompletionTime: null,
      //签收时间
      takeOverTime: null,
      //供应商列表
      boxLis: '',
      //开户名
      accountName: '',
      //银行卡号
      accountNumber: '',
      //开户行
      bankName: '',
      //付款备注
      paymentRemark: '',
      //付款完成备注
      paymentCompletionRemark: '',
      //入库备注
      procurementRemark: '',
      //供应商ID
      supplierId: '',
      //供应商名字
      supplierName: '',
      //是否开票
      invoice: '',
      //采购单状态
      isPurchaseOrder: '',
      //采购单号
      purchaseOrderNo: '',
      //总价
      total_price: 0,
      //配件单价
      price2: '',

      parts: '',
      processInstanceId: '',
      //付款方式
      payment: '',
      parts2: '',
      parts3: 0,
      current: 0,
      current2: 0,
      added2: '',
      steps: [
        {
          title: '新建采购单',
          content: 'form-content',
        },
        {
          title: '付款申请',
          content: 'Second-content',
        },
        {
          title: '财务付款',
          content: 'Last-content',
        },
        {
          title: '物流发货',
          content: 'Last-content',
        },
        {
          title: '入库',
          content: 'Last-content',
        },
      ],
      steps2: [
        {
          title: '新建采购单',
          content: 'form-content',
        },
        {
          title: '物流发货',
          content: 'Last-content',
        },
        {
          title: '付款申请',
          content: 'Second-content',
        },
        {
          title: '财务付款',
          content: 'Last-content',
        },

        {
          title: '入库',
          content: 'Last-content',
        },
      ],
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),

      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
    }
  },
  beforeCreate() {
    this.form4 = this.$form.createForm(this, { name: 'dynamic_form_item' })
    this.form4.getFieldDecorator('keys', { initialValue: [], preserve: true })
  },
  async created() {
    // 供应商
    selectenterprise({}).then((res) => {
      console.log(res)
      this.boxLis = res.rows
    })
    // 配件
    selectaccessory({}).then((res) => {
      console.log(res)
      this.parts = res.rows
    })

    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('delivery_company')
    this.restaurantOperTypeMap.forEach((value, key) => {
      this.restaurantTypes.push({ code: key, label: value })
    })
  },
  methods: {
    moment,

    handleSubmit2() {
      this.visible = false
    },

    delContract2() {
      getPurchasePic({ purchaseOrderId: this.purchaseOrderId }).then((res) => {
        if (res.code == 0) {
          console.log(res)
          this.fileLists = res.rows[0]
          this.fileLists2 = res.rows[1]
          this.fileLists3 = res.rows[2]
          this.fileLists4 = res.rows[3]
          this.fileLists5 = res.rows[4]
        } else {
          this.$message.success(res.msg)
        }
      })
    },

    // 删除
    delContract(record) {
      console.log('record', record)
      this.purchasePicId = record.purchasePicId
      const purchasePics2 = {
        purchasePicId: record.purchasePicId,
        delFlag: 1,
      }
      delPurchasePic(purchasePics2).then((res) => {
        if (res.code == 0) {
          console.log(res)

          this.$message.success('删除成功')
          this.delContract2()
        } else {
          this.$message.success(res.msg)
        }
      })
    },

    //下载
    delByIds(value) {
      console.log('value', value)
      window.open(
        process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          value.picUrl +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      )
    },

    //上传
    uploadChange(info) {
      console.log(info)
      if (this.current == 0 && this.current2 == 0) {
        this.fileList1 = info.fileList
      } else if (this.current == 1) {
        this.fileList2 = info.fileList
      } else if (this.current == 2) {
        this.fileList3 = info.fileList
      } else if (this.current == 3) {
        this.fileList4 = info.fileList
      } else if (this.current2 == 1) {
        this.fileList4 = info.fileList
      } else if (this.current2 == 2) {
        this.fileList2 = info.fileList
      } else if (this.current2 == 3) {
        this.fileList3 = info.fileList
      }

      let that = this
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        console.log('info', info)
        if (this.current == 0 && this.current2 == 0) {
          this.fileName = info.file
          this.fileList1 = info.fileList
        } else if (this.current == 1) {
          this.fileList2 = info.fileList
          this.fileName2 = info.file
        } else if (this.current == 2) {
          this.fileList3 = info.fileList
          this.fileName3 = info.file
        } else if (this.current == 3) {
          this.fileList4 = info.fileList
          this.fileName4 = info.file
        } else if (this.current2 == 1) {
          this.fileList4 = info.fileList
          this.fileName4 = info.file
        } else if (this.current2 == 2) {
          this.fileList2 = info.fileList
          this.fileName2 = info.file
        } else if (this.current2 == 3) {
          this.fileList3 = info.fileList
          this.fileName3 = info.file
        }

        // that.UpdataContract()
        that.$message.success(`上传成功`)
        // this.fileList1=[]
      } else if (info.file.status === 'error') {
        this.$message.error(`上传失败`)
        this.fileList1 = []
      }
    },

    // 启用
    enableContract(record) {
      this.purchasePicId = record.purchasePicId
      console.log('record', record)
      const purchasePics2 = {
        purchasePicId: record.purchasePicId,
        forbiddenStatus: 0,
      }
      delPurchasePic(purchasePics2).then((res) => {
        if (res.code == 0) {
          console.log(res)
          this.delContract2()
          this.$message.success('启用成功')
        } else {
          this.$message.success(res.msg)
        }
      })
    },

    // 禁用
    disableContract(record) {
      this.purchasePicId = record.purchasePicId
      console.log('record', record)
      const purchasePics = {
        purchasePicId: record.purchasePicId,
        forbiddenStatus: 1,
      }
      delPurchasePic(purchasePics).then((res) => {
        if (res.code == 0) {
          // this.forbiddenStatus = 0
          console.log(res)
          this.delContract2()
          this.$message.success('禁用成功')
        } else {
          this.$message.success(res.msg)
        }
      })
    },

    //采购单预计到货时间
    estimated(time, timeString) {
      this.expectedDeliveryTime = timeString
      console.log(time, expectedDeliveryTime)
    },
    //入库
    warehousing() {
      const shipping = {
        payment: this.payment,
        purchaseOrderId: this.purchaseOrderId,
      }
      manualaccessorystorage(shipping)
        .then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('保存成功')
            this.$emit('ok')
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },

    //出库
    returnGoods() {
      let record = {
        purchaseOrderId: this.purchaseOrderId,
        payment: this.payment,
      }
      this.$refs.editorder1.refreshOrder(record)
    },

    //银行卡号正则表达式
    async bankNum(rule, value, callback) {
      const pwdRegex = /^[1-9]\d{7,29}$/
      console.log(value)
      if (value == undefined || value.length == 0) {
        callback()
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的银行卡号'))
      }
      callback()
    },

    // 添加物流
    handleadd1() {
      this.storeLogistics.push({
        transportCodes: '',
        transportNos: '',
        transportStatusList: '',
      })
    },

    // 移除添加
    removeTab1(item) {
      let index = this.storeLogistics.indexOf(item)
      if (index !== -1) {
        //当没有多余tab时就不再删除
        this.storeLogistics.splice(index, 1)
      }
    },

    generate(record) {
      ;(this.supplierId = ''), (this.supplierName = ''), console.log(record)
      this.auditStatus = record.auditStatus
      this.purchaseOrderId = record.purchaseOrderId
      this.idss = 2
      this.added = 2
      if (record.payment == '先付款') {
        var payment = 0
      } else {
        var payment = 1
      }
      getonepurchaseorder({ purchaseOrderId: record.purchaseOrderId, payment: payment }).then((res) => {
        console.log(res)
        if (res.code === 0) {
          this.visible = true
          if (res.data.payment == 0) {
            this.processInstanceId = res.data.processInstanceId
            this.purchaseOrderNo = res.data.purchaseOrderNo
            this.supplierId = res.data.supplierId
            this.payment = res.data.payment
            this.invoice = res.data.invoice
            this.total_price = res.data.total_price
            this.remark = res.data.remark
            this.count = parseInt(res.data.key)
            this.dataSource = res.data.purchaseAccessories
            console.log(res.data.isPurchaseOrder)
            console.log(this.current)
            this.current = 0
            this.needTime = res.data.needTime
            // this.current = res.data.isPurchaseOrder
            console.log(this.needTime)
            console.log(this.current)
            this.$emit('ok')
          }
        } else {
          this.$message.error('系统错误，请稍后再试')
        }
      })
    },

    procurementRemark(time, timeString) {
      this.takeOverTimeStr = timeString
      console.log(time, timeString)
    },

    remove(k) {
      const { form4 } = this
      // can use data-binding to get
      const keys = form4.getFieldValue('keys')
      // We need at least one passenger
      if (keys.length === 1) {
        return
      }

      // can use data-binding to set
      form4.setFieldsValue({
        keys: keys.filter((key) => key !== k),
      })
    },

    add2() {
      const { form4 } = this
      // can use data-binding to get
      const keys = form4.getFieldValue('keys')
      const nextKeys = keys.concat(id++)
      // can use data-binding to set
      // important! notify form to detect changes
      form4.setFieldsValue({
        keys: nextKeys,
      })
    },

    onCellChange(key, dataIndex, value) {
      if (dataIndex == 'purchasePrice') {
        for (var i = 0, total = 0; i < this.dataSource.length; i++) {
          if (i == key) {
            this.dataSource[i].price = Math.round((value / this.dataSource[i].accessoryNumber) * 100) / 100
            total += parseInt(this.dataSource[i].purchasePrice)

            console.log(this.dataSource[i].price)
          }
        }
        this.purchasePrice = dataIndex
        console.log(total)
        //
        // for (var j = 0,total = 0; j < this.dataSource.length; j++) {
        //   // this.total_price = 0 + this.dataSource[j].purchasePrice
        //
        //   this.dataSource[j].purchasePrice = parseInt(this.dataSource[j].purchasePrice)
        //
        //   total += this.dataSource[j].purchasePrice
        //
        // }
        // this.total_price = total
      }
      console.log(this.total_price)
      const dataSource = [...this.dataSource]
      const target = dataSource.find((item) => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.dataSource = dataSource
        for (var j = 0, total = 0; j < this.dataSource.length; j++) {
          // this.total_price = 0 + this.dataSource[j].purchasePrice
          if (this.dataSource[j].purchasePrice == null) {
            this.dataSource[j].purchasePrice == 0
          }
          this.dataSource[j].purchasePrice = Number(this.dataSource[j].purchasePrice)

          total += this.dataSource[j].purchasePrice
        }
        this.total_price = total
      }
    },

    onDelete(key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== key)
    },

    // 动态表格
    handleAdd2() {
      console.log(this.price)
      console.log(this.accessoryNumber)
      console.log(this.accessoryNumber * this.price)
      this.purchasePrice = this.accessoryNumber * this.price
      console.log(this.parts)
      var parts = this.parts
      console.log(parts)

      console.log(this.count)
      const { count, dataSource } = this
      const newData = {
        key: count,
        accessoryId: this.accessoryId,
        accessoryName: this.accessoryName,
        accessoryType: this.accessoryType,
        accessoryCategory: this.accessoryCategory,
        accessorySpecification: this.accessorySpecification,
        accessoryNumber: this.accessoryNumber,
        price: this.price,
        purchasePrice: this.purchasePrice,
        remark: this.remark,
      }
      this.dataSource = [...dataSource, newData]
      console.log(this.dataSource)
      for (var j = 0, total = 0; j < this.dataSource.length; j++) {
        // this.total_price = 0 + this.dataSource[j].purchasePrice
        total += this.dataSource[j].purchasePrice
      }
      console.log(total)
      this.total_price = total
      console.log(this.total_price)
      console.log(this.dataSource)
      this.count = count + 1
    },

    priceBlur() {
      this.total_price = this.accessoryNumber * this.price
    },
    accessoryNumberBlur() {
      let str = {}
      str.accessoryId = this.accessoryId
      str.supplierId = this.supplierId
      str.priceUnit = this.accessoryNumber
      getUnitPrice(str).then((res) => {
        this.price = res.data
        this.total_price = this.accessoryNumber * res.data
      })
    },
    onChange4(value) {
      if (value == 0) {
        this.dispatch = 0
      } else {
        this.dispatch = 1
      }
    },

    //获取配件Id
    onChange2(values) {
      for (let k = 0; k < this.parts.length; k++) {
        if (this.parts[k].accessoryId == values) {
          this.unityPrice = this.parts[k].unityPrice
        }
      }

      console.log(values)
      this.accessoryId = values
      let boxLis = this.parts
      for (let i = 0; i < boxLis.length; i++) {
        if (boxLis[i].accessoryId == values) {
          this.accessoryId = boxLis[i].accessoryId
          this.accessoryName = boxLis[i].accessoryName
          this.accessoryType = boxLis[i].accessoryType
          this.accessoryCategory = boxLis[i].accessoryCategory
          this.accessorySpecification = boxLis[i].accessorySpecification
        }
      }
    },

    // 获取供应商Id

    onChange3(values) {
      this.supplierId = values

      getSupplierPayment({ supplierId: values }).then((res) => {
        if (res.code == 0) {
          this.payment = res.data
        }
        console.log(res)
        this.parts = res.rows
        selectaccessory({ supplierId: values }).then((res) => {
          console.log(res)
          this.parts = res.rows
        })
      })
      console.log(this.boxLis)
      var boxLis = this.boxLis
      for (let i = 0; i < boxLis.length; i++) {
        if (values == boxLis[i].supplierId) {
          this.supplierName = boxLis[i].supplierName
        }
      }
      console.log(values)
    },

    // 需求时间
    onChangeTiem(time, timeString) {
      //this.timeString = timeString
      this.needTime = timeString
      this.needTime2 = time
      console.log(time, this.needTime)
    },
    // 付款开始时间
    onChangetiem2(time, timeString) {
      this.expectedPaymentTimeBegin = timeString

      console.log(time, this.expectedPaymentTimeBegin)
    },
    // 付款结束时间
    onChangeTiem3(time, timeString) {
      this.expectedPaymentTimeEnd = timeString

      console.log(time, this.expectedPaymentTimeEnd)
    },
    // 付款完成时间
    onChangeTime4(time, timeString) {
      this.paymentCompletionTime = timeString

      console.log(time, this.paymentCompletionTime)
    },
    // 签收时间
    onChangeTiem5(time, timeString) {
      this.takeOverTime = timeString

      console.log(time, this.takeOverTime)
    },

    // 正常流程 下一步
    next(e) {
      console.log(this.purchaseOrderId)
      if (this.payment == 0) {
        this.parts3 = 0
      }
      console.log(this.current)
      if (this.current == 0) {
        if (this.auditStatus == 1) {
          if (this.supplierId == null) {
            this.$message.error('请选择供应商')
          } else {
            const purchaseOrder = {
              supplierId: this.supplierId,
              purchaseAccessories: this.dataSource,
            }
            checkSupplier(purchaseOrder).then((res) => {
              if (res.code == 0) {
                if (res.data != '') {
                  this.$message.error('该供应商暂无以下配件：' + res.data)
                } else {
                  intentiontopurchase({ purchaseOrderId: this.purchaseOrderId }).then((res) => {
                    if (res.code == 0) {
                      if (this.supplierId == undefined || this.supplierId == '') {
                        this.$message.error('请选择供应商')
                      } else {
                        console.log('res', res)
                        console.log(this.dataSource)
                        // var dataSource = this.dataSource
                        e.preventDefault()
                        this.form.validateFields(() => {
                          const purchaseOrder = {
                            processInstanceId: this.processInstanceId,
                            processStep: this.current,
                            needTime: this.needTime,
                            purchaseOrderNo: this.purchaseOrderNo,
                            isPurchaseOrder: 1,
                            supplierId: this.supplierId,
                            payment: this.payment,
                            purchaseOrderId: this.purchaseOrderId,
                            totalPrice: this.total_price,
                            purchaseAccessories: this.dataSource,
                          }

                          if (this.validator6()) {
                            return true
                          } else {
                            console.log('Received values of form: ', purchaseOrder)
                            console.log(purchaseOrder)
                            this.confirmLoading = true
                            editPurchaseApplication(purchaseOrder)
                              .then((res) => {
                                console.log(res)
                                if (res.code === 0) {
                                  this.confirmLoading = false
                                  this.$message.success('保存成功')
                                  this.$router.go(0)
                                  this.current++
                                  this.visible = false
                                  this.$emit('ok', 1)
                                } else {
                                  this.$message.success(res.msg)
                                }
                              })
                              .catch(() => {
                                this.$message.error('系统错误，请稍后再试')
                              })
                          }
                        })
                      }
                    }
                  })
                }
              }
            })
          }
        } else {
          console.log(this.dataSource)
          var dataSource = this.dataSource
          e.preventDefault()
          this.form.validateFields(() => {
            const purchaseOrder = {
              processInstanceId: this.processInstanceId,
              processStep: this.current,
              needTime: this.needTime,
              purchaseOrderNo: this.purchaseOrderNo,
              isPurchaseOrder: 1,
              supplierId: this.supplierId,
              payment: this.payment,
              purchaseOrderId: this.purchaseOrderId,
              totalPrice: this.total_price,
              purchaseAccessories: this.dataSource,
            }
            if (this.needTime == null) {
              this.$message.error('需求时间，不能为空')
            } else {
              if (purchaseOrder.needTime._i != null) {
                purchaseOrder.needTime = purchaseOrder.needTime._i
              }
              if (this.validator10()) {
                return true
              } else {
                console.log('Received values of form: ', purchaseOrder)
                console.log(purchaseOrder)
                //this.confirmLoading = true
                editpurchaseorder(purchaseOrder)
                  .then((res) => {
                    console.log(res)
                    if (res.code === 0) {
                      this.$message.success('保存成功')
                      this.current++
                      this.visible = false
                      this.$emit('ok', 1)
                    } else {
                      this.$message.success(res.msg)
                    }
                  })
                  .catch(() => {
                    this.$message.error('系统错误，请稍后再试')
                  })
              }
            }
          })
        }
      } else if (this.current == 1) {
        const values3 = {
          processInstanceId: this.processInstanceId,
          purchaseOrderNo: this.purchaseOrderNo,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
          isPurchaseOrder: 2,
          accountName: this.accountName,
          accountNumber: this.form2.getFieldValue('accountNumber'),
          // accountNumber: this.accountNumber,

          bankName: this.bankName,
          expectedPaymentTimeBegin: this.expectedPaymentTimeBegin,
          expectedPaymentTimeEnd: this.expectedPaymentTimeEnd,
          paymentRemark: this.paymentRemark,
        }
        if (this.fileName2) {
          values3.purchasePics = [
            {
              picName: this.fileName2.name,
              picType: 1,
              picUrl: this.fileName2.response.url,
            },
          ]
        }

        if (this.validator2()) {
          return
        } else {
          console.log('Received values of form: ', values3)
          console.log(values3)
          editpurchaseorder(values3)
            .then((res) => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.current++
                this.visible = false
                this.$emit('ok', 1)
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      } else if (this.current == 2) {
        const values3 = {
          processInstanceId: this.processInstanceId,
          purchaseOrderNo: this.purchaseOrderNo,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
          isPurchaseOrder: 3,
          paymentCompletionRemark: this.paymentCompletionRemark,
          paymentCompletionTime: this.paymentCompletionTime,
        }
        if (this.fileName3) {
          values3.purchasePics = [
            {
              picName: this.fileName3.name,
              picType: 2,
              picUrl: this.fileName3.response.url,
            },
          ]
        }
        if (this.validator3()) {
          return
        } else {
          console.log('Received values of form: ', values3)
          console.log(values3)
          editpurchaseorder(values3)
            .then((res) => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.current++
                this.visible = false
                this.$emit('ok', 1)
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      } else if (this.current == 3) {
        const shipping = {
          processInstanceId: this.processInstanceId,
          purchaseOrderNo: this.purchaseOrderNo,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
          isPurchaseOrder: 4,

          storeLogistics: this.storeLogistics,
          expectedDeliveryTime: this.expectedDeliveryTime,
        }

        if (this.fileName4) {
          shipping.purchasePics = [
            {
              picName: this.fileName4.name,
              picType: 3,
              picUrl: this.fileName4.response.url,
            },
          ]
        }
        if (this.validator4()) {
          return
        } else {
          editpurchaseorder(shipping)
            .then((res) => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.current++
                this.visible = false
                this.$emit('ok', 1)
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      } else {
        const shipping = {
          processInstanceId: this.processInstanceId,
          purchaseOrderNo: this.purchaseOrderNo,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
          isPurchaseOrder: 5,

          procurementRemark: this.procurementRemark,
          takeOverTime: this.takeOverTime,
        }
        if (this.validator5()) {
          return
        } else {
          const shipping2 = {
            payment: this.payment,
            purchaseOrderId: this.purchaseOrderId,
          }
          manualaccessorystorage(shipping2).then((res) => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.$emit('ok', 1)
            } else {
              this.$message.success(res.msg)
            }
            editpurchaseorder(shipping)
              .then((res) => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok', 1)
                  this.visible = false
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
          })
        }
      }
    },

    //正常流程 返回
    prev() {
      console.log('current', this.current)
      if (this.current == 0) {
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 0,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current--
            this.$emit('ok', 1)
            this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current == 1) {
        this.accountName = ''
        this.accountNumber = ''
        this.bankName = ''
        this.expectedPaymentTimeBegin = null
        this.expectedPaymentTimeEnd = null
        this.paymentRemark = ''
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 0,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current == 2) {
        this.paymentCompletionRemark = ''
        this.paymentCompletionTime = ''
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 1,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current == 3) {
        this.storeLogistics = []
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 2,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current == 4) {
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 3,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current == 5) {
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 4,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      }
    },

    //后付款流程
    next2(e) {
      if (this.payment == 1) {
        this.parts3 = 1
      }

      if (this.current2 == 0) {
        if (this.auditStatus == 1) {
          if (this.supplierId == null) {
            this.$message.error('请选择供应商')
          } else {
            const purchaseOrder = {
              supplierId: this.supplierId,
              purchaseAccessories: this.dataSource,
            }
            checkSupplier(purchaseOrder).then((res) => {
              if (res.code == 0) {
                if (res.data != '') {
                  this.$message.error('该供应商暂无以下配件：' + res.data)
                } else {
                  intentiontopurchase({ purchaseOrderId: this.purchaseOrderId }).then((res) => {
                    if (res.code == 0) {
                      if (this.supplierId == undefined || this.supplierId == '') {
                        this.$message.error('请选择供应商')
                      } else {
                        console.log('res', res)
                        console.log(this.dataSource)
                        // var dataSource = this.dataSource
                        e.preventDefault()
                        this.form.validateFields(() => {
                          const purchaseOrder = {
                            processInstanceId: this.processInstanceId,
                            processStep: this.current,
                            needTime: this.needTime,
                            purchaseOrderNo: this.purchaseOrderNo,
                            isPurchaseOrder: 1,
                            supplierId: this.supplierId,
                            payment: this.payment,
                            purchaseOrderId: this.purchaseOrderId,
                            totalPrice: this.total_price,
                            purchaseAccessories: this.dataSource,
                          }

                          if (this.validator6()) {
                            return true
                          } else {
                            console.log('Received values of form: ', purchaseOrder)
                            console.log(purchaseOrder)
                            this.confirmLoading = true
                            editPurchaseApplication(purchaseOrder)
                              .then((res) => {
                                console.log(res)
                                if (res.code === 0) {
                                  this.confirmLoading = false
                                  this.$message.success('保存成功')
                                  // this.$router.go(0)
                                  this.current++
                                  this.visible = false
                                  this.$emit('ok', 1)
                                } else {
                                  this.$message.success(res.msg)
                                }
                              })
                              .catch(() => {
                                this.$message.error('系统错误，请稍后再试')
                              })
                          }
                        })
                      }
                    }
                  })
                }
              }
            })
          }
        } else {
          e.preventDefault()
          this.form.validateFields(() => {
            const values2 = {
              processStep: this.current2,
              needTime: this.needTime,
              purchaseOrderNo: this.purchaseOrderNo,
              // isPurchaseOrder:this.isPurchaseOrder,
              isPurchaseOrder: 1,
              supplierId: this.supplierId,
              payment: this.payment,
              total_price: this.total_price,
              purchaseAccessories: this.dataSource2,
            }
            if (this.fileName) {
              values2.purchasePics = [
                {
                  picName: this.fileName.name,
                  picType: 0,
                  picUrl: this.fileName.response.url,
                },
              ]
            }
            if (this.needTime == null) {
              this.$message.error('需求时间，不能为空')
            } else {
              if (values2.needTime._i != null) {
                values2.needTime = values2.needTime._i
              }
              if (this.validator10()) {
                return true
              } else {
                console.log('Received values of form: ', values2)
                //this.confirmLoading = true
                savePurchaseOrder(values2)
                  .then((res) => {
                    console.log(res)
                    if (res.code === 0) {
                      this.$message.success('保存成功')
                      this.$emit('ok', 1)
                      this.current2++
                      this.visible = false
                    } else {
                      this.$message.success(res.msg)
                    }
                  })
                  .catch(() => {
                    this.$message.error('系统错误，请稍后再试')
                  })
                  .finally(() => {
                    this.confirmLoading = false
                  })
              }
            }
          })
        }
      } else if (this.current2 == 1) {
        const shipping = {
          processInstanceId: this.processInstanceId,
          purchaseOrderNo: this.purchaseOrderNo,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
          isPurchaseOrder: 2,

          storeLogistics: this.storeLogistics,
          expectedDeliveryTime: this.expectedDeliveryTime,
        }
        if (this.fileName4) {
          shipping.purchasePics = [
            {
              picName: this.fileName4.name,
              picType: 1,
              picUrl: this.fileName4.response.url,
            },
          ]
        }
        if (this.validator4()) {
          return
        } else {
          editpurchaseorder(shipping)
            .then((res) => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok', 1)
                this.current2++
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      } else if (this.current2 == 2) {
        const values3 = {
          processInstanceId: this.processInstanceId,
          purchaseOrderNo: this.purchaseOrderNo,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
          isPurchaseOrder: 3,
          // processStep:this.current,
          accountName: this.accountName,
          accountNumber: this.accountNumber,

          bankName: this.bankName,
          expectedPaymentTimeBegin: this.expectedPaymentTimeBegin,
          expectedPaymentTimeEnd: this.expectedPaymentTimeEnd,
          paymentRemark: this.paymentRemark,
        }
        if (this.fileName2) {
          values3.purchasePics = [
            {
              picName: this.fileName2.name,
              picType: 2,
              picUrl: this.fileName2.response.url,
            },
          ]
        }
        if (this.validator2()) {
          return
        } else {
          console.log('Received values of form: ', values3)
          console.log(values3)
          editpurchaseorder(values3)
            .then((res) => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.current2++
                this.visible = false
                this.$emit('ok', 1)
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      } else if (this.current2 == 3) {
        const values3 = {
          processInstanceId: this.processInstanceId,
          purchaseOrderNo: this.purchaseOrderNo,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
          isPurchaseOrder: 4,
          paymentCompletionRemark: this.paymentCompletionRemark,
          paymentCompletionTime: this.paymentCompletionTime,
        }
        if (this.fileName3) {
          values3.purchasePics = [
            {
              picName: this.fileName3.name,
              picType: 3,
              picUrl: this.fileName3.response.url,
            },
          ]
        }
        if (this.validator3()) {
          return
        } else {
          console.log('Received values of form: ', values3)
          console.log(values3)
          editpurchaseorder(values3)
            .then((res) => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok', 1)
                this.current2++
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      } else {
        const shipping = {
          processInstanceId: this.processInstanceId,
          purchaseOrderNo: this.purchaseOrderNo,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
          isPurchaseOrder: 5,

          procurementRemark: this.procurementRemark,
          takeOverTime: this.takeOverTime,
        }
        if (this.validator5()) {
          return
        } else {
          const shipping2 = {
            payment: this.payment,
            purchaseOrderId: this.purchaseOrderId,
          }
          manualaccessorystorage(shipping2).then((res) => {
            console.log(res)
            if (res.code === 0) {
            } else {
              this.$message.success(res.msg)
            }
            editpurchaseorder(shipping)
              .then((res) => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok', 1)
                  this.visible = false
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
          })
        }
      }
    },

    //后付款 返回
    prev2() {
      console.log('current', this.current)
      if (this.current2 == 0) {
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 0,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current2--
            this.$emit('ok', 1)
            this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current2 == 1) {
        this.accountName = ''
        this.accountNumber = ''
        this.bankName = ''
        this.expectedPaymentTimeBegin = null
        this.expectedPaymentTimeEnd = null
        this.paymentRemark = ''
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 0,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current2--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current2 == 2) {
        this.paymentCompletionRemark = ''
        this.paymentCompletionTime = ''
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 1,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current2--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current2 == 3) {
        this.storeLogistics = []
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 2,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current2--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current2 == 4) {
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 3,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current2--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      } else if (this.current2 == 5) {
        const values = {
          processInstanceId: this.processInstanceId,
          isPurchaseOrder: 4,
          purchaseOrderId: this.purchaseOrderId,
          payment: this.payment,
        }
        editpurchaseorder(values).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('返回成功')
            this.current2--
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.success(res.msg)
          }
        })
      }
    },

    //新增
    add(record) {
      // 第一步下载文件
      this.fileLists = ''
      this.fileName = ''
      this.fileList1 = []
      // 第二步下载文件
      this.fileLists2 = ''
      this.fileName2 = ''
      this.fileList2 = []
      // 第三步下载文件
      this.fileLists3 = ''
      this.fileName3 = ''
      this.fileList3 = []
      // 第四步下载文件
      this.fileLists4 = ''
      this.fileName4 = ''
      this.fileList4 = []
      // 第五步下载文件
      this.fileLists5 = ''
      this.fileName5 = ''
      ;(this.fileList5 = []), (this.current = 0), (this.current2 = 0), (this.expectedDeliveryTime = null)
      this.operateType = ''
      this.storeLogistics = []
      this.dataSource = []
      this.dataSource2 = []
      this.dispatch = ''
      this.price = ''
      this.accessoryNumber = ''
      // 采够单Id
      this.purchaseOrderId = ''
      this.accessoryName = ''
      this.accessoryType = ''
      this.accessoryCategory = ''
      this.accessorySpecification = ''
      this.purchasePrice = ''
      //需求时间
      this.timeString = null
      this.needTime = null
      //付款开始时间
      this.expectedPaymentTimeBegin = null
      //付款结束时间
      this.expectedPaymentTimeEnd = null
      //付款完成时间
      this.paymentCompletionTime = null
      //签收时间
      this.takeOverTime = null
      //供应商列表
      this.boxLis = ''
      //开户名
      this.accountName = ''
      //银行卡号
      this.accountNumber = ''
      //开户行
      this.bankName = ''
      //付款备注
      this.paymentRemark = ''
      //付款完成备注
      this.paymentCompletionRemark = ''
      //入库备注
      this.procurementRemark = ''
      //供应商ID
      this.supplierId = ''
      //供应商名字
      this.supplierName = ''
      //是否开票
      this.invoice = ''
      //采购单状态
      this.isPurchaseOrder = ''
      //采购单号
      this.purchaseOrderNo = ''

      //配件单价
      this.price2 = ''
      this.remark = ''
      //付款方式
      this.payment = ''

      var date = new Date() //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear()
      var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      var ms = ''
      if (date.getMilliseconds() < 10) {
        ms = '00' + date.getMilliseconds()
      } else if (date.getMilliseconds() < 100) {
        ms = '0' + date.getMilliseconds()
      } else {
        ms = date.getMilliseconds()
      }
      var num = Math.floor(Math.random() * 10)

      this.purchaseOrderNo = `C${Y}${M}${D}${h}${m}${s}${ms}${num}`

      if (record.purchaseOrderId != null) {
        this.added = 1
        var purchaseOrderId = record.purchaseOrderId
        getonepurchaseapplication({ purchaseOrderId: purchaseOrderId }).then((res) => {
          console.log(res)
          //res.data
        })
      } else {
        console.log('aaa')
        console.log(record)
        this.added = 1
        console.log(this.added)

        this.form.resetFields()
        this.edit({ purchaseOrderId: 0 })
        // selectaccessory({}).then(res => {
        //   console.log(res)
        //   this.parts = res.rows
        // })
        selectenterprise({}).then((res) => {
          console.log(res)
          this.boxLis = res.rows
        })
      }
    },

    edit(record) {
      // 第一步下载文件
      this.fileLists = ''
      this.fileName = ''
      this.fileList1 = []
      // 第二步下载文件
      this.fileLists2 = ''
      this.fileName2 = ''
      this.fileList2 = []
      // 第三步下载文件
      this.fileLists3 = ''
      this.fileName3 = ''
      this.fileList3 = []
      // 第四步下载文件
      this.fileLists4 = ''
      this.fileName4 = ''
      this.fileList4 = []
      // 第五步下载文件
      this.fileLists5 = ''
      this.fileName5 = ''
      ;(this.fileList5 = []), (this.idss = 1)
      console.log('paymentCompletionTime', record.paymentCompletionTime)
      console.log(record)
      //this.current=1
      this.purchaseOrderId = record.purchaseOrderId
      // this.needTime = record.needTime
      if (record.purchaseOrderId == null || record.purchaseOrderId == 0) {
        this.added = 1
        this.visible = true
        console.log(this.added)
      } else {
        if (record.operateType == 0) {
          this.added = 3
          this.operateType = 0
          if (record.operateTransport == 1) {
            this.operateTransport = 1
          } else {
            this.operateTransport = 0
          }
        } else {
          this.added = 2
        }
        // selectaccessory({}).then(res => {
        //     console.log(res)
        //     this.parts = res.rows

        selectenterprise({}).then((res) => {
          console.log(res)
          this.boxLis = res.rows
        })
        // })

        if (record.payment == '先付款') {
          var payment = 0
        } else {
          var payment = 1
        }
        getonepurchaseorder({ purchaseOrderId: record.purchaseOrderId, payment: payment }).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.visible = true
            if (res.data.payment == 0) {
              this.processInstanceId = res.data.processInstanceId
              this.purchaseOrderNo = res.data.purchaseOrderNo
              this.supplierId = res.data.supplierId
              this.payment = res.data.payment
              this.invoice = res.data.invoice
              this.total_price = res.data.totalPrice
              this.remark = res.data.remark
              this.count = parseInt(res.data.key)
              this.dataSource = res.data.purchaseAccessories
              console.log(res.data.isPurchaseOrder)
              console.log(this.current)
              this.current = res.data.isPurchaseOrder
              if (res.data.needTime != null) {
                this.needTime = moment(res.data.needTime)
                this.needTime2 = moment(res.data.needTime)
              } else {
                this.needTime = null
                this.needTime2 = null
              }

              this.fileLists = res.data.fileLists[0]
              console.log(this.needTime)
              console.log(this.current)

              //开户名
              this.accountName = ''
              //银行卡号
              // this.form2.setFieldsValue({
              //   accountNumber:res.data.accountNumber,
              // })
              this.accountNumber = ''
              //开户行
              this.bankName = ''

              this.expectedPaymentTimeBegin = null
              this.expectedPaymentTimeEnd = null

              this.paymentRemark = ''
              this.fileLists2 = res.data.fileLists[1]

              this.paymentCompletionTime = null

              this.paymentCompletionRemark = ''
              this.fileLists3 = []

              if (res.data.isPurchaseOrder != 1) {
                //开户名
                this.accountName = res.data.accountName
                //银行卡号
                // this.form2.setFieldsValue({
                //   accountNumber:res.data.accountNumber,
                // })
                this.accountNumber = res.data.accountNumber
                //开户行
                this.bankName = res.data.bankName
                if (res.data.expectedPaymentTimeBegin != null) {
                  this.expectedPaymentTimeBegin = moment(res.data.expectedPaymentTimeBegin)
                  this.expectedPaymentTimeEnd = moment(res.data.expectedPaymentTimeEnd)
                } else {
                  this.expectedPaymentTimeBegin = null
                  this.expectedPaymentTimeEnd = null
                }
                this.paymentRemark = res.data.paymentRemark
                this.fileLists2 = res.data.fileLists[1]
                if (res.data.isPurchaseOrder != 2) {
                  if (res.data.paymentCompletionTime != null) {
                    this.paymentCompletionTime = moment(res.data.paymentCompletionTime)
                  } else {
                    this.paymentCompletionTime = null
                  }
                  this.paymentCompletionRemark = res.data.paymentCompletionRemark
                  this.fileLists3 = res.data.fileLists[2]
                  if (res.data.isPurchaseOrder != 3) {
                    this.storeLogistics = res.data.storeLogistics
                    if (res.data.expectedDeliveryTime != null) {
                      this.expectedDeliveryTime = moment(res.data.expectedDeliveryTime)
                    } else {
                      this.expectedDeliveryTime = null
                    }
                    this.fileLists4 = res.data.fileLists[3]
                    if (res.data.isPurchaseOrder != 4) {
                      if (res.data.takeOverTime != null) {
                        this.takeOverTime = moment(res.data.takeOverTime)
                      } else {
                        this.takeOverTime = null
                      }
                      this.procurementRemark = res.data.procurementRemark
                      this.fileLists5 = res.data.fileLists[4]
                      if (record.operateType == 0) {
                        this.current = 4
                      }
                    }
                  }
                }
              }
            } else if (res.data.payment == '1') {
              this.dataSource2 = res.data.purchaseAccessories
              this.dispatch = 1
              if (res.data.needTime != null) {
                this.needTime = moment(res.data.needTime)
              } else {
                this.needTime = null
              }
              this.fileLists = res.data.fileLists[0]
              this.processInstanceId = res.data.processInstanceId
              this.purchaseOrderNo = res.data.purchaseOrderNo
              this.supplierId = res.data.supplierId
              this.payment = res.data.payment
              this.invoice = res.data.invoice
              this.total_price = res.data.totalPrice
              this.remark = res.data.remark
              this.count2 = parseInt(res.data.key)
              this.dataSource2 = res.data.purchaseAccessories
              console.log(res.data.isPurchaseOrder)
              console.log(this.current)
              this.current2 = res.data.isPurchaseOrder

              // this.current = res.data.isPurchaseOrder
              console.log(this.needTime)
              console.log(this.current)
              if (res.data.isPurchaseOrder != 1) {
                if (res.data.expectedDeliveryTime != null) {
                  this.expectedDeliveryTime = moment(res.data.expectedDeliveryTime)
                } else {
                  this.expectedDeliveryTime = null
                }
                this.storeLogistics = res.data.storeLogistics
                this.fileLists4 = res.data.fileLists[1]
                if (res.data.isPurchaseOrder != 2) {
                  //开户名
                  this.accountName = res.data.accountName
                  //银行卡号
                  this.accountNumber = res.data.accountNumber
                  //开户行
                  this.bankName = res.data.bankName
                  if (res.data.expectedPaymentTimeBegin != null) {
                    this.expectedPaymentTimeBegin = moment(res.data.expectedPaymentTimeBegin)
                    this.expectedPaymentTimeEnd = moment(res.data.expectedPaymentTimeEnd)
                  } else {
                    this.expectedPaymentTimeBegin = null
                    this.expectedPaymentTimeEnd = null
                  }

                  this.paymentRemark = res.data.paymentRemark
                  this.fileLists2 = res.data.fileLists[2]
                }
                if (res.data.isPurchaseOrder != 3) {
                  if (res.data.paymentCompletionTime != null) {
                    this.paymentCompletionTime = moment(res.data.paymentCompletionTime)
                  } else {
                    this.paymentCompletionTime = null
                  }
                  this.paymentCompletionRemark = res.data.paymentCompletionRemark
                  this.fileLists3 = res.data.fileLists[3]
                  if (res.data.isPurchaseOrder != 4) {
                    if (res.data.takeOverTime != null) {
                      this.takeOverTime = moment(res.data.takeOverTime)
                    } else {
                      this.takeOverTime = null
                    }
                    this.procurementRemark = res.data.procurementRemark
                    if (record.operateType == 0) {
                      this.current2 = 4
                    }
                  }
                }
              }
            }
          } else {
            this.$message.error('系统错误，请稍后再试')
          }
        })
      }
    },

    handleSubmit(e) {
      if (this.operateType === 0) {
        if (this.operateTransport == 1) {
          const values2 = {
            purchaseOrderId: this.purchaseOrderId,
            storeLogistics: this.storeLogistics,
            invoice: this.invoice,
          }
          updatePurchaseLogistics(values2).then((res) => {
            if (res.code == 0) {
              // console.log("res",res)
              this.$message.success('保存成功')
              this.visible = false
              this.$emit('ok')
            }
          })
        } else {
          this.visible = false
        }
        this.visible = false
      } else {
        if (this.validator()) {
          return
        } else {
          if (this.added != 1) {
            this.visible = false
          } else {
            e.preventDefault()
            this.iconLoading = true
            this.form.validateFields((err, values) => {
              console.log(this.dataSource)
              console.log(this.fileName, 'this.fileNamethis.fileNamethis.fileNamethis.fileName')
              if (!err) {
                let values2 = {
                  invoice: this.invoice,
                  processStep: this.current,
                  needTime: this.needTime,
                  purchaseOrderNo: this.purchaseOrderNo,
                  // isPurchaseOrder:this.isPurchaseOrder,
                  supplierId: this.supplierId,
                  payment: this.payment,
                  totalPrice: this.total_price,
                  purchaseAccessories: this.dataSource,
                  // purchasePics: [{
                  //   picName: this.fileName.name,
                  //   picType: 0,
                  //   picUrl: this.fileName.response.url
                  // }]
                }
                if (this.fileName) {
                  values2.purchasePics = [
                    {
                      picName: this.fileName.name,
                      picType: 0,
                      picUrl: this.fileName.response.url,
                    },
                  ]
                }
                if (this.validator8()) {
                  return
                } else {
                  console.log('Received values of form: ', values2)

                  addpurchaseorder(values2)
                    .then((res) => {
                      if (res.code === 0) {
                        this.iconLoading = false

                        this.$message.success('保存成功')
                        this.$emit('ok')
                        this.visible = false
                      } else {
                        this.iconLoading = false
                        this.$message.success(res.msg)
                      }
                    })
                    .catch(() => {
                      this.iconLoading = false
                      this.$message.error('系统错误，请稍后再试')
                    })
                    .finally(() => {
                      this.iconLoading = false
                    })
                }
              }
            })
          }
        }
      }
    },

    // 付款申请
    validator2() {
      if (
        this.expectedPaymentTimeBegin == '' ||
        this.expectedPaymentTimeBegin == null ||
        this.expectedPaymentTimeBegin == undefined
      ) {
        this.$message.success('付款开始时间不能为空')
        return true
      }
      if (
        this.expectedPaymentTimeEnd == '' ||
        this.expectedPaymentTimeEnd == null ||
        this.expectedPaymentTimeEnd == undefined
      ) {
        this.$message.success('付款结束时间不能为空')
        return true
      }
      if (this.accountName == '' || this.accountName == null || this.accountName == undefined) {
        this.$message.success('开户名不能为空')
        return true
      }
      if (this.accountNumber == '' || this.accountNumber == null || this.accountNumber == undefined) {
        this.$message.success('银行账号不能为空')
        return true
      }
      if (this.bankName == '' || this.bankName == null || this.bankName == undefined) {
        this.$message.success('开户行不能为空')
        return true
      }
    },

    // 财务付款
    validator3() {
      if (
        this.paymentCompletionTime == '' ||
        this.paymentCompletionTime == null ||
        this.paymentCompletionTime == undefined
      ) {
        this.$message.success('付款完成时间不能为空')
        return true
      }
    },

    // 物流发货
    validator4() {
      for (let i = 0; i < this.storeLogistics.length; i++) {
        if (
          this.storeLogistics[i].transportCode == '' ||
          this.storeLogistics[i].transportCode == null ||
          this.storeLogistics[i].transportCode == undefined
        ) {
          this.$message.success('快递公司不能为空')
          return true
        }
        if (
          this.storeLogistics[i].transportNo == '' ||
          this.storeLogistics[i].transportNo == null ||
          this.storeLogistics[i].transportNo == undefined
        ) {
          this.$message.success('快递单号不能为空')
          return true
        }
        if (
          this.storeLogistics[i].transportStatus === '' ||
          this.storeLogistics[i].transportStatus === null ||
          this.storeLogistics[i].transportStatus === undefined
        ) {
          this.$message.success('物流状态不能为空')
          return true
        }
      }
      if (
        this.expectedDeliveryTime == '' ||
        this.expectedDeliveryTime == null ||
        this.expectedDeliveryTime == undefined
      ) {
        this.$message.success('预计到货时间不能为空')
        return true
      }
    },

    // 入库
    validator5() {
      if (this.takeOverTime == '' || this.takeOverTime == null || this.takeOverTime == undefined) {
        this.$message.success('签收时间不能为空')
        return true
      }
    },

    validator8() {
      if (this.dataSource.length == 0) {
        this.$message.success('配件信息不能为空')
        return true
      }
    },

    validator6() {
      if (this.dataSource.length == 0) {
        this.$message.error('请输入配件信息总价')
        return true
      } else {
        for (let i = 0; i < this.dataSource.length; i++) {
          if (
            this.dataSource[i].purchasePrice == undefined ||
            this.dataSource[i].purchasePrice == null ||
            this.dataSource[i].purchasePrice == ''
          ) {
            this.$message.error('配件信息总价,不能为空')
            return true
          }
        }
      }
    },

    validator() {
      if (this.current == 0) {
        if (this.needTime == '' || this.needTime == null || this.needTime == undefined) {
          this.$message.success('需求时间不能为空')
          return true
        }
        if (this.supplierName == '' || this.supplierName == null || this.supplierName == undefined) {
          this.$message.success('供应商不能为空')
          return true
        }

        if (this.payment == '' || this.payment == null || this.payment == undefined) {
          this.$message.success('付款方式不能为空')
          return true
        }
        if (this.payment == '' || this.payment == null || this.payment == undefined) {
          this.$message.success('是否开票不能为空')
          return true
        }

        if (this.accessoryName == '' || this.accessoryName == null || this.accessoryName == undefined) {
          this.$message.success('配件不能为空')
          return true
        }
        if (this.price == '' || this.price == null || this.price == undefined) {
          this.$message.success('单价不能为空')
          return true
        }
        if (this.accessoryNumber == '' || this.accessoryNumber == null || this.accessoryNumber == undefined) {
          this.$message.success('数量不能为空')
          return true
        }
      } else if (this.current == 1) {
      }
    },

    validator10() {
      if (this.current == 0) {
        if (this.needTime == '' || this.needTime == null || this.needTime == undefined) {
          this.$message.success('需求时间不能为空')
          return true
        }
        if (this.supplierName == '' || this.supplierName == null || this.supplierName == undefined) {
          this.$message.success('供应商不能为空')
          return true
        }

        if (this.payment == '' || this.payment == null || this.payment == undefined) {
          this.$message.success('付款方式不能为空')
          return true
        }
        if (this.payment == '' || this.payment == null || this.payment == undefined) {
          this.$message.success('是否开票不能为空')
          return true
        }
      }
    },
  },
  //   async handleRestaurantTypeChange(value){
  //
  //     console.log(value)
  //     this.restaurantLists = [];
  //     this.queryParam.type = value;
  //     let arr = [];
  //     await getMetroScheduleList (this.queryParam).then(function (result) {
  //       arr = result.rows;
  //     });
  //     this.restaurantLists = arr;
  //   },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
<style>
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
</style>